module.exports = __webpack_public_path__ + "img/125.10.e6b740c5.png";